import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from 'common/react/components/select';
import { getTranslation } from 'common/react/utils/translations';
import { playerStatsNavSelector } from 'store/modules/mc-player-stats/selectors';
import { STATS_CATEGORY } from '../table/config/categories';
import { setNavItem } from 'common/store/modules/mc-player-stats/init';

export const StatsNavItem = () => {
    const dispatch = useDispatch();
    const nav = useSelector(playerStatsNavSelector);

    return (
        <Select
            items={Object.keys(STATS_CATEGORY).map(
                (key) => STATS_CATEGORY[key]
            )}
            initialSelectedItem={nav.stats}
            activeItem={nav.stats}
            label={getTranslation('label.stats')}
            onSelectedItemChange={({ selectedItem }) => {
                dispatch(
                    setNavItem({
                        navItem: 'stats',
                        value: selectedItem
                    })
                );
            }}
        />
    );
};
